module.exports = __webpack_public_path__ + "static/Finance2-28152fc48c6d049a93e43b554d025a15.png";